var VectorLayer = require("./VectorLayer"),
    ol = require("openlayers"),
    _ = require("underscore"),
    $ = require("jquery"),
    utils = require("Utils");

var devPixelRatio = 1 / utils.getDevicePixelRatio();

var OmsVectorLayer = VectorLayer.extend({

    _setup: function(options){
        var that = this,
            vStyle,
            clusterSizeOptionsOverride;

        options || (options = {});

        if('projectLayers' in options){
            that._prjLayers = options.projectLayers;
        }

        if(that._prjLayers && that._prjLayers.getLength() > 0){
            clusterSizeOptionsOverride = that._prjLayers.at(0).options.clusterSize || {};
            that.cluserSizeOptions = {
                // желательно иметь небольшой буфер вокруг рисуемых фигур (в данном случае 1px с каждой стороны 20x17 vs 18x15)
                // т.к. на устройствах с нечётным pixel ratio, например galaxy tab, при масштабировании canvas
                // теряется часть однопиксельной обводки. При толстой обводке, или при рисовании circle это не так критично
                width       : 20,
                height      : 17,
                // допустимые figures и их опции в Utils.createObjectsCountCnv
                figures     : [
                    // по умолчанию
                    {
                        width       : 18,
                        height      : 15,
                        type        : 'rect',
                        radius      : 2,
                        strokeStyle : '#7fa3c6',
                        fillStyle   : '#fff',
                        lineWidth   : 1
                    }
                ],
                fontSize    : 20,
                fontFamily  : 'Arial',
                textAlign   : 'center',
                textBaseline: 'middle',
                textColor   : '#000'
            };
            // deep extend не нужен, т.к. figures "по умолчанию" нужно перетереть новыми
            $.extend(
                that.cluserSizeOptions, 
                clusterSizeOptionsOverride, 
                that.view.options.misc_data.objects_counter_style
            );
            vStyle = that._prjLayers.at(0).get('vectorSettings');
            if (!vStyle) {
                throw new Error("Not enough parameters to create a vector layer");
            }
            if (vStyle['clusteringEnabled']) {
                that.options['clustering'] = vStyle['clusterSettings'].radius;
            }

            that.project = that._prjLayers.at(0).options.project;

            OmsVectorLayer.__super__._setup.call(that, options);

            that._setZoomRange();
            that.switchLayerSource();
            that.setLayerStyle();
        }

        return that;
    },

    updateLayer: function() {
        var that = this;
        OmsVectorLayer.__super__.updateLayer.call(that);

    },

    onAdd: function(view){
        var that = this;
        that.view = view;
        that.map = view.getMap();
        that.map.getView().on('change:resolution', function(){
            if (that._prjLayers) {
                that.switchLayerSource();
            }
        });
    },

    switchLayerSource: function(){
        var that = this;
        var zoom;
        var cStyle = that._prjLayers.at(0).get('vectorSettings').clusterSettings;

        if (!that.map) {
            return;
        }
        zoom = that.map.getView().getZoom();

        if (that._prjLayers.at(0).get('vectorSettings').clusteringEnabled) {
            if (cStyle['maxZoomEnabled'] && zoom > cStyle.maxZoom) {
                that._olLayer.setSource(that._olSource);
            } else {
                that._olLayer.setSource(that._olClusterSource);
            }
        } else {
            that._olLayer.setSource(that._olSource);
        }
    },


    _setZoomRange: function(){
        var that = this,
            vStyle = that._prjLayers.at(0).get('vectorSettings'),
            startResolution = 156543.03392804097;

        if (vStyle['zoomsEnabled']) {
            that._olLayer.setMinResolution(startResolution / Math.pow(2, vStyle.maxZoom));
            that._olLayer.setMaxResolution(startResolution / Math.pow(2, vStyle.minZoom)+0.5);
        } else {
            that._olLayer.setMinResolution(startResolution / Math.pow(2, 22));
            that._olLayer.setMaxResolution(startResolution+0.5);
        }
    },

    _createImgLoader: function(iconUrl) {
        var that = this;

        that.imgCache[iconUrl] = new Image();
        that.imgCache[iconUrl].def = $.Deferred();
        that.imgCache[iconUrl].crossOrigin = 'anonymous';
        that.imgCache[iconUrl].onload = function(){
            this.def.resolve(true);
        };
        return that.imgCache[iconUrl].def;
    },

    _reloadLayerIcons: function(){
        var that = this,
            master = $.Deferred(),
            defs = [],
            i, vStyle,
            url;

        vStyle = that._prjLayers.at(0).get('vectorSettings');

        that.imgCache = {};

        if (vStyle.stylesPoint.icon) {
            defs.push(that._createImgLoader(vStyle.stylesPoint.icon));
        }


        if (vStyle.clusteringEnabled && vStyle.clusterSettings.icon  && vStyle.clusterSettings.iconEnabled 
            && that.imgCache[vStyle.clusterSettings.icon] === undefined) {
            defs.push(that._createImgLoader(vStyle.clusterSettings.icon));
        }

        if (_.isEmpty(that.imgCache)) {
            master.resolve(true);
            return master;
        }

        $.when.apply($,defs).then(function(){
            master.resolve(true);
        });

        for (i in that.imgCache) {
            url = that.project.apiUrlLocation.protocol
                  + '//'
                  + that.project.apiUrlLocation.hostname
                  + i + '?r=' + Math.floor(Math.random() * (999999)) + 1;
            that.imgCache[i].src = url;
        }
        return master;
    },

    setLayerStyle: function(){
        var that = this,
            layer = that._olLayer,
            vStyle = that._prjLayers.at(0).get('vectorSettings'),
            iconImg;

        // update images, then set layer style function
        that._reloadLayerIcons().done(function(){

            // Чистим сохраненные стили
            that.styleCache = {};
            layer.setStyle(function(feature, resolution){
                var size = feature.get('features') ? feature.get('features').length : 1,
                    styles = [],
                    scale,
                    offset = vStyle.stylesPoint.iconOffsetEnabled
                        ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
                        : [0,0];

                if (resolution+'' in that.styleCache) {
                    if (that.styleCache[resolution+''][size]) {
                        return that.styleCache[resolution+''][size];
                    }
                } else {
                    that.styleCache[resolution+''] = [];
                }

                if (size > 1) {

                    var min = 2, max = 2;
                    layer.getSource().getFeatures().forEach(function(f){
                        min = Math.min(min, f.get('features').length);
                        max = Math.max(max, f.get('features').length);
                    });

                    var sizeDelta = vStyle.clusterSettings.iconSizeMax - vStyle.clusterSettings.iconSizeMin;
                    var iconSize = parseInt(vStyle.clusterSettings.iconSizeMin + sizeDelta * (size-min)/(max-min));

                    if (vStyle.clusterSettings.icon != null && vStyle.clusterSettings.iconEnabled) {
                        iconImg = that.imgCache[vStyle.clusterSettings.icon];
                        offset = vStyle.clusterSettings.iconOffsetEnabled
                            ? [-vStyle.clusterSettings.iconDx, -vStyle.clusterSettings.iconDy]
                            : [0,0];
                    } else {
                        iconImg = that.imgCache[vStyle.stylesPoint.icon];
                        offset = vStyle.stylesPoint.iconOffsetEnabled
                            ? [-vStyle.stylesPoint.iconDx, -vStyle.stylesPoint.iconDy]
                            : [0,0];
                    }

                    offset[0] += iconImg.width/2;
                    offset[1] += iconImg.height/2;

                    scale =  vStyle.clusterSettings.iconSizeEnabled ? iconSize/iconImg.width : 1;

                    styles.push(new ol.style.Style({
                        image: new ol.style.Icon({
                            anchor: offset,
                            anchorXUnits: 'pixels',
                            anchorYUnits: 'pixels',
                            opacity: 1,
                            img: iconImg,
                            imgSize:[iconImg.width,iconImg.height],
                            scale: scale
                        })
                    }));

                    // count style
                    if (vStyle.clusterSettings.showObjectsCount) {
                        try {
                            scale = 1 / (that.pixelRatio || devPixelRatio);
                            var countIcon = utils.createObjectsCountCnv(size < 100 ? size.toString() : '*', scale,
                                that.cluserSizeOptions);
                                styles.push(new ol.style.Style({
                                image: new ol.style.Icon({
                                    anchor: [
                                        (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
                                        (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
                                    ],
                                    anchorXUnits: 'pixels',
                                    anchorYUnits: 'pixels',
                                    opacity: 1,
                                    imgSize: [countIcon.width, countIcon.height],
                                    img: countIcon,
                                    scale: 1 / scale
                                })
                            }));
                        } catch (err) {
                            console.error(err);
                        }
                    }
                } else {
                    // one feature style
                    iconImg = that.imgCache[vStyle.stylesPoint.icon];
                    offset[0] += iconImg.width/2;
                    offset[1] += iconImg.height/2;

                    styles.push(new ol.style.Style({
                        image: new ol.style.Icon({
                            anchor: offset,
                            anchorXUnits: 'pixels',
                            anchorYUnits: 'pixels',
                            opacity: 1,
                            img: iconImg,
                            imgSize:[iconImg.width,iconImg.height]
                        })
                    }));
                }

                that.styleCache[resolution+''][size] = styles;
                return styles;
            });
        });
    }
});

module.exports = OmsVectorLayer;


//////////////////
// WEBPACK FOOTER
// ./src/View/OmsVectorLayer.js
// module id = 45
// module chunks = 0